module.exports = __webpack_public_path__ + "img/logo-assinatura-ministerio.7f5bee92.png";